module.exports = __webpack_public_path__ + "static/img/8_IMG_20151229_144925.9e0983d2.jpg";